import { Component } from '@angular/core';
import { Storage } from '@ionic/storage';
import { NavController } from 'ionic-angular';
import { WelcomePage } from '../welcome/welcome';
import { PainelPage } from '../painel/painel';
import { ComercialPage } from '../comercial/comercial';
import { FaturamentoPage } from '../faturamento/faturamento';
import { ProducaoPage } from '../producao/producao';
import { CortePage } from '../corte/corte';
import { ComprasPage } from '../compras/compras';

@Component({
    selector: 'page-home',
    templateUrl: 'home.html'
})
export class HomePage {
    public rootPage: PainelPage = PainelPage;

    public comercialPage: any = ComercialPage;
    public faturamentoPage: any = FaturamentoPage;
    public producaoPage: any = ProducaoPage;
    public cortePage: any = CortePage;
    public comprasPage: any = ComprasPage;

    constructor(
        private _storage: Storage,
        private _navCtrl: NavController
    ) { }

    public logout(): void {
        this._storage.set('manter', false);
        this._navCtrl.setRoot(WelcomePage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts